// 存储对象形式的cookie
export function setCookie(name, value, minutes) {
    let expires = "";
    if (minutes) {
      let date = new Date();
      // date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      date.setTime(date.getTime() + (minutes * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
}
  
// 读取对象形式的cookie
export function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return JSON.parse(c.substring(nameEQ.length, c.length));
    }
    return null;
}
  
// 删除cookie
export function removeCookie(name) {
    document.cookie = name + '=; Max-Age=-99999999;';
}